import React from 'react'
import { Typography } from 'antd';

const { Title } = Typography;

const titleStyle = {    
    color: "white",
    margin:"80px"
}

function Space() {
  return (
    <div>
        <Title level={1} style={titleStyle}>Space</Title>
    </div>
  )
}

export default Space